/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React, { useState } from "react";
import { Platform, TouchableOpacity, View } from "react-native";
import Icon from "react-icons-kit";
import { ic_chevron_left } from "react-icons-kit/md/ic_chevron_left";

import { Text } from "UpduoLibrary";
import { colorWithLuminance, skaleWebTextGray } from "config/UpduoColors";

interface BackButtonProps {
  color?: string;
  fontSize?: number;
  text?: string;
  onPress: () => void;
  disabled?: boolean;
}

export default function BackButton({
  color = skaleWebTextGray,
  fontSize = 16,
  text = "Back",
  onPress,
  disabled = false,
}: BackButtonProps) {
  const [isHovering, setIsHovering] = useState(false);
  const backBtnColor = isHovering ? colorWithLuminance(color, 0.6) : color;

  return (
    <TouchableOpacity
      disabled={disabled}
      onPress={onPress}
      {...Platform.select({
        web: {
          onMouseEnter: () => {
            setIsHovering(true);
          },
          onMouseLeave: () => {
            setIsHovering(false);
          },
        },
      })}
    >
      <View
        style={{
          alignSelf: "flex-start",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <div
          style={{
            color: backBtnColor,
          }}
        >
          <Icon size={22} icon={ic_chevron_left} />
        </div>
        {text ? (
          <Text
            style={{
              color: backBtnColor,
              fontSize,
              marginLeft: 3,
              fontWeight: "500",
            }}
          >
            {text}
          </Text>
        ) : null}
      </View>
    </TouchableOpacity>
  );
}
